import SharePage from './SharePage.jsx'

export default () => {
    return {
        path: '/share/:id',
        element: <SharePage />,
    }
}
